import axios from 'axios';
axios.defaults.headers.common['Cache-Control'] = 'no-store';
axios.defaults.headers.common.Pragma = 'no-cache';
axios.defaults.headers.common.Expires = 0;
let callRequestDomain = window.callRequestDomain || '';
const DEFAULT_URL_PREFIX = '/apps/callback-frontend/api/callback';
export default {
	getTimetableAndCaptcha(params, urlPrefix) {
		urlPrefix = urlPrefix || DEFAULT_URL_PREFIX;
		return axios.get(`${callRequestDomain}${urlPrefix}/init`, {
			params
		});
	},
	sendCallrequest(params, urlPrefix) {
		urlPrefix = urlPrefix || DEFAULT_URL_PREFIX;
		return axios.post(`${callRequestDomain}${urlPrefix}/submit`, params);
	}
};
